import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Grid, Button } from '@material-ui/core';
import _uniqBy from 'lodash-es/uniqBy';

import { Label } from 'core/components/label';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';

const PowerOutage = ({ classes, errors }) => {
  const { submitForm } = useFormikContext();
  const { offer: store } = useStore();
  const onClick = () => {
    submitForm();
    store.triggerOfferDialog(false);
  };

  const uniqueErrors = errors ? _uniqBy(errors, (error) => error.message) : [];
  const messageList = uniqueErrors?.map(({ message }) => message) || [];

  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Power Outage
      </Label>
      <Label type="infoInnerTitle">
        Sorry about that. It looks like our systems are not able process the policy update. Please try again
      </Label>
      {messageList.length > 0 &&
        messageList.map((message, idx) => (
          <Label key={idx} type="infoValue" className={classes.content}>
            {message}
          </Label>
        ))}
      <Grid container alignItems="center" justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Try again</Label>
        </Button>
      </Grid>
    </>
  );
};

PowerOutage.propTypes = {
  classes: PropTypes.object.isRequired,
  errors: PropTypes.array
};

PowerOutage.defaultProps = {
  errors: []
};

export default observer(PowerOutage);
